export const myNewsTranslationsHu = {
  MY_NEWS_CONTENT_IS_REQUIRED: "A tartalom megadása kötelező!",
  MY_NEWS_DESCRIPTION_IS_REQUIRED: "A bevezető megadása kötelező!",
  MY_NEWS_TITLE_IS_REQUIRED: "A cím megadása kötelező!",
  MY_NEWS_END_DATE: "Vége dátum",
  MY_NEWS_START_DATE: "Kezdő dátum",
  MY_NEWS_NEWS: "Hírek",
  MY_NEWS_ADMIN_GUIDE: "MyNews adminisztrátori kézikönyv",
  MY_NEWS_EDITOR_GUIDE: "MyNews szerkesztői kézikönyv",
  MY_NEWS_USER_GUIDE: "MyNews felhasználói kézikönyv",
  MY_NEWS_DATE_CANNOT_BE_EARLIER: "Ez a dátum nem lehet korábbi a mai napnál!",
  MY_NEWS_NO_NEWS: "Jelenleg nincs hír!",
  MY_NEWS_EMBED_VIDEO: "Videó beágyazása",
  MY_NEWS_HUGE: "Óriási",
  MY_NEWS_LARGE: "Nagy",
  MY_NEWS_MEDIUM: "Közepes",
  MY_NEWS_SMALL: "Kicsi",
  MY_NEWS_EDIT_MY_NEWS_ITEM: "Hír szerkesztése",
  MY_NEWS_READ_AGAIN: "Elolvas újra",
  MY_NEWS_DELETE_CONFIRM_INFO: "Valóban törli a hírt?",
  MY_NEWS_MENU_ALLOWED_INFO: "A MyNews bekapcsolásával a rendszerbe belépve minden dolgozó számára elérhetővé válik a MyNews kezdő képernyője és funkciói.",
  MY_NEWS_EDITED: "Szerkesztve",
  MY_NEWS_ARCHIVED_NEWS: "Archivált hír!",
  MY_NEWS_UNPUBLISHED_NEWS: "Nem közzétett hír!",
  MY_NEWS_READ: "Elolvas",
  MY_NEWS_EDITING: "Szerkeszt",
  MY_NEWS_IMPORTANT: "Fontos",
  MY_NEWS_OWN_NEWS: "Híreim",
  MY_NEWS_ARCHIVED: "Archív",
  MY_NEWS_ACTUAL: "Aktuális",
  MY_NEWS_SAVE_AND_PUBLISH: "Mentés és közzététel",
  MY_NEWS_DESCRIPTION: "Bevezető",
  MY_NEWS_TITLE: "Cím",
  MY_NEWS_NEW_ITEM: "Új hír",
};
